module.exports = __webpack_public_path__ + "static/blue-bg2-8613be0bed6d676ae809ef5582ebaec4.jpg";